import { getPrTotalSize } from 'common/utils/prs.utils';
import { StyledCell } from '../../Table.style';

const PRMetricValueCell = ({ pr }) => {
  return (
    <StyledCell data-testid='pr-size-metric-value'>
      {getPrTotalSize(pr)}
    </StyledCell>
  );
};

export default PRMetricValueCell;
